module.exports = __webpack_public_path__ + "static/recruit_home__targetting-persons-3a92b784b6ab31da6929fdbaf602a8d0.jpg";